<template>
    <div class="panel panel-default table-of-contents margin-above">
        <div class="panel-heading">
            <h4>Options</h4>
        </div>
        <div class="panel-body">
            <div class="row">
                <div class="col-lg-3">
                    <strong class="margin-left">Tags</strong>
                </div>
                <div class="col-lg-9">
                    <autocomplete-tag
                        :current-tags="currentTags"
                        :user-tags="userTagsFlat"
                        @tag-update="updateTags"
                    />
                    <span class="help-block">
                        Add tags for these items, new tags (shown darker) will be created for you.
                        Press enter to create and separate your tags.
                    </span>
                </div>
            </div>
            <div v-if="type === 'sddf'" class="row">
                <hr>
                <div class="col-lg-3">
                    <strong class="margin-left">Workgroup</strong>
                </div>
                <div class="col-lg-9">
                    <div class="form-group">
                        <select class="form-control" @change="changeSelectedWorkgroup" :value="selectedWorkGroup">
                            <option disabled value="">
                                Select a Workgroup
                            </option>
                            <option v-for="workgroup in JSON.parse(userWorkgroups)"
                                    :value="workgroup.id"
                                    :key="workgroup.id"
                            >
                                {{ workgroup.name }}
                            </option>
                        </select>
                        <span class="help-block">
                            Select a workgroup for these items.
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AutocompleteTag from '@/tags/AutoCompleteTag.vue'
import {flatten} from "src/lib/utils.js"

export default {
    name: "FileUploaderOptions",
    components: {
        AutocompleteTag,
    },
    props: {
        userTags: {
            type: String,
            required: true,
        },
        userWorkgroups: {
            type: String,
            required: true,
        },
        selectedWorkGroup: {
            type: String,
            required: true,
        },
        type: {
            type: String,
            required: true,
        },
    },
    data: () => ({
        currentTags: [],
    }),
    computed: {
        userTagsFlat: function() {
            return flatten(this.jsonParsedUserTags, 'name')
        },
    },
    created() {
        this.jsonParsedUserTags = JSON.parse(this.userTags)
    },
    methods: {
        updateTags: function (tags) {
            this.currentTags = tags
            this.$emit('changeTags', tags)
        },
        changeSelectedWorkgroup: function () {
            this.$emit('changeSelectedWorkgroup', event.target.value)
        },
    },
}
</script>

<style scoped>

</style>
